AuthRoute = require 'mixins/authenticated-route'

App.DeliveryIndexRoute = Em.Route.extend AuthRoute,
  afterModel: ->
    @transitionTo('delivery.couriers')